import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from './icons/QuestionBlueIcon.jsx';

const StakeholdersCurrentCSVDownloadButton = ({ onDownloadCsv }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const handleShow = () => setShowModal(true);

  const renderModal = () => (
    <Modal bsSize="sm" show={showModal} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          Use the following steps to bulk upload stakeholders to the Stakeholder
          Structure:
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol>
          <li className="text-muted">Download the Stakeholders CSV below.</li>
          <li className="text-muted">
            Edit the CSV and add the stakeholder details you want to include in
            the Stakeholder Structure.
          </li>
          <li className="text-muted">
            Save the edited or new file as a CSV and upload it to ChangeSync.
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button block bsStyle="primary" onClick={onDownloadCsv} target="_blank">
          Download Stakeholders CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <React.Fragment>
      <button
        aria-label="View help"
        type="button"
        className="btn-clear flex flex-align-center p-0 text-muted text-left"
        onClick={handleShow}
      >
        Need a Current Stakeholder Structure CSV? Click the question mark to
        download &nbsp;
        <QuestionBlueIcon />
      </button>
      {renderModal()}
    </React.Fragment>
  );
};

export default StakeholdersCurrentCSVDownloadButton;
